import React__default from 'react';
import { SidebarIcon } from '../sidebarIcon/index.js';
import '../../../t_types/enums/overlayTypes.js';

var SidebarHolder = function (_a) {
    var children = _a.children, hasSideIcon = _a.hasSideIcon, setGameControllerType = _a.setGameControllerType, sideIcon = _a.sideIcon;
    return (React__default.createElement("div", { className: 'pgc-left-side-holder' },
        children,
        hasSideIcon && React__default.createElement(SidebarIcon, { setGameControllerType: setGameControllerType, sideIcon: sideIcon })));
};

export { SidebarHolder };
